import React from "react";
import plan from "../assets/plan.png";
import execute from "../assets/execute.png";
import manage from "../assets/manage.png";
import "./whatweoffer.css";
import whatWeOffer from "../assets/whatweoffer.jpg"

const WhatWeOffer = () => {
  return (
    <section className="what-we-offer">
      {/* Left Side Content */}
      <div className="text-content">
        <h2 className="offer-title">WHAT WE OFFER</h2>
        <p className="offer-description">
          Purchase of any financial products without consulting a financial planner is like taking medicine without a 
          doctor’s diagnosis. We offer expert advice for choosing the best investment products that will lead to your financial freedom.
        </p>

        <div className="offer-item">
          <img src={plan} alt="Plan" />
          <div>
            <h3 className="offer-item-title">PLAN</h3>
            <p className="offer-item-text">Get customized advice across investments, goals, expenses, insurance, loans, estate planning, and taxes.</p>
          </div>
        </div>

        <div className="offer-item">
          <img src={execute} alt="Execute" />
          <div>
            <h3 className="offer-item-title">EXECUTE</h3>
            <p className="offer-item-text">Implement your customized advice by buying all the recommended financial products on one single platform.</p>
          </div>
        </div>

        <div className="offer-item">
          <img src={manage} alt="Manage" />
          <div>
            <h3 className="offer-item-title">MANAGE</h3>
            <p className="offer-item-text">Track your journey and rebalance your investments to make sure they are aligned with your goals.</p>
          </div>
        </div>
      </div>

      {/* Right Side Image */}
      <div className="image-content">
        <img src={whatWeOffer} alt="Financial Planning" />
      </div>
    </section>
  );
};

export default WhatWeOffer;
